export default __webpack_public_path__ + "e0e54931e9a44ac38059777b4434476b.png";